import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { faChurch } from '@fortawesome/free-solid-svg-icons';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { HttpClient } from '@angular/common/http';
import { Router, RouterModule } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { BannerSliderComponent } from "../_components/banner-slider/banner-slider.component";
import { BannerCardComponent } from "../_components/banner-card/banner-card.component";
import { WhatsNewArticlesComponent } from "../_components/whats-new-articles/whats-new-articles.component";
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [DataServiceService],
        imports: [
          CommonModule, 
          FormsModule, 
          ReactiveFormsModule, 
          FontAwesomeModule, 
          RouterModule, 
          BannerSliderComponent, 
          BannerCardComponent,
          WhatsNewArticlesComponent,
          LazyLoadImageModule
        ]
})
export class HomeComponent implements OnInit {

  title = "Investing for Catholics - Faith Based Investing";

  videos

  name = "";
  email = "";
  isNameValid = null;
  isEmailValid = null;
  isSending = false;
  newsletterFormMessage = "";

  faChurch = faChurch;
  faPiggyBank = faPiggyBank;
  faUser = faUser;
  lazyLoadImage = 'https://services.ifa.com/art/images/3646_255x330_c_ifc-brochure-2026_q80.webp';

  constructor(
    public hc: HttpClient, 
    public router: Router, 
    private dataservice: DataServiceService, 
    private seoservice: SeoService, 
    private meta: Meta,
  private cdr: ChangeDetectorRef) {

    this.dataservice.getAllVideos().subscribe(resp => {
      var allResultsCombined = [];
      for(var r=0;r<resp.length;r++){
        //console.log("each part:",resp[r])
        allResultsCombined = allResultsCombined.concat(resp[r]);
      }
      //console.log("home > getAllVideos", resp, resp.length);
       if(allResultsCombined.length>8){
        allResultsCombined = allResultsCombined.slice(0,8);
       };

      allResultsCombined = allResultsCombined.map( x => { 

        x.imageUrl = x.imageUrl?(x.imageUrl.replace('http://', 'https://').replace("177x100", "285x160").replace(/\.(png|jpg|jpeg)$/, "_q80.webp")):"https://services.ifa.com/art/images/1640_512x288_c_ifc-generic-article-banner.png"; return x }); //fallback to logo image for articles
       
      //removes first article from header
      this.videos = allResultsCombined;
      this.cdr.markForCheck();

    })

   }

   newsletterFormSubmit() {

    console.log("newsletterFormSubmit", this.name, this.email, this.isNameValid, this.isEmailValid)

    if (this.isNameValid && this.isEmailValid) {

      this.isSending = true;

      var newsletterSubmission = {
        email: this.email,
        list:"9022188",
      };

      this.subscribeToEmailList(newsletterSubmission);

    } else {

    }

  }

  // error messages of input fields
  errorMessages = {
    name: 'Name must be at least 3 characters.',
    email: 'Email is invalid.',
  };


  subscribeToEmailList(dta) {

    var promise = this.hc.post("https://data2.ifa.com/api/v1/email/newslettersubscribe", dta)
    promise.subscribe((resp: any) => {
       this.newsletterFormMessage = "You successfully signed up for our newsletter";     
    }, error => {
      this.newsletterFormMessage = error
       this.newsletterFormMessage = "An error occured while signing up for the newsletter, please try again.";
    }, () => {
      this.cdr.markForCheck();
    })
  }


  nameValidationText = "";
  emailValidationText = "";

  validateName() {
    this.isNameValid = (this.name.length >= 2);
    if (this.isNameValid) {
      this.nameValidationText =  "";
    } else {
      this.nameValidationText = (this.errorMessages.name);
    }
  }

  validateEmail() {
    var emailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.isEmailValid = emailRegEx.test(this.email);
    if (this.isEmailValid) {
      this.emailValidationText = "";
    } else {
      this.emailValidationText = (this.errorMessages.email);
    }
  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'faith based investing, investing for catholics, catholic mutual funds, faith based index funds, catholic investing'});
    this.meta.addTag({name: 'description', content: 'A clear path for catholic investors who want to include faith-based strategies into a research based, time-tested investment approach.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
